import { createContext, useContext } from "react";

/**
 * Contexto pra reduzir prop drilling nos componentes extraídos de
 * WorkoutAdminModal.jsx (StudentsTab, e futuramente StudentAssignmentModal,
 * PlansTab, AIGenerateModal — migração feita um componente por vez, ver
 * docs/07-issues.md issue 012).
 *
 * WorkoutAdminModal.jsx continua sendo o dono de todo o estado (useState/
 * useCallback) — esse contexto só evita ter que listar dezenas de props
 * manualmente em cada <Componente ... /> e na assinatura de cada função.
 * Cada componente migrado usa useWorkoutAdminContext() e desestrutura só o
 * que precisa, em vez de receber tudo via props.
 *
 * Sem valor default proposital (null): usar o hook fora de um Provider é
 * bug de wiring, não estado válido — por isso o hook lança erro nesse caso,
 * em vez de silenciosamente deixar handlers undefined.
 */
export const WorkoutAdminContext = createContext(null);

export function useWorkoutAdminContext() {
  const ctx = useContext(WorkoutAdminContext);
  if (!ctx) {
    throw new Error(
      "useWorkoutAdminContext precisa ser usado dentro de <WorkoutAdminContext.Provider>."
    );
  }
  return ctx;
}
